module.exports = __webpack_public_path__ + "static/media/alfredo_moreira_fonseca.cce527c9.jpg";